'use client';

import { OptimizelyProvider, createInstance } from '@optimizely/react-sdk';

import { ProductNames } from '../../constants/ProductNames';
import { PropsWithChildren } from 'react';
import clientConfig from '../../client/config';
import { isMobileDevice } from '../../utils/mobile';
import { usePage } from './PageProvider';

const optimizelyClient = createInstance({
  sdkKey: clientConfig.optimizelyFullstackKey,
  eventBatchSize: 10,
  eventFlushInterval: 300,
});

export const ExperimentProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { charity, campaign, product: {name: productName} } = usePage();

  const getDeviceType = () => {
    if (typeof window !== "undefined") return isMobileDevice() ? 'Mobile' : 'Desktop';
    return '';
  };

  const getCauseType = () => {
    if (productName === ProductNames.Fundraising) {
      return campaign? 'DonationCampaignFRP': 'DonationCharityFRP'
    }
    // TODO: Add logic for additional causeType values as required
    return '';
  }

  const userId = typeof document !== "undefined" ? document.cookie?.match?.(/logged_out_guid=([A-Za-z0-9-]*)/)?.[1] ?? null : null;

  const attributes = {
    deviceType: getDeviceType(),
    charityId: charity.externalId.toString(),
    marketCode: charity.countryCode,
    causeType: getCauseType()
  };

  return (
    <OptimizelyProvider
      optimizely={optimizelyClient}
      user={{ id: userId, attributes }}
    >
      {children}
    </OptimizelyProvider>
  );
};
